import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = ({ wordcloud1, wordcloud2, wordcloud3 }) => {
  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: true,
    swipeToSlide: true,
  };

  return (
    <div
      style={{
        width: "100%",
        // maxWidth: "600px",
        position: "relative",
        // padding: "0 10px", // Reduced padding to 10px on each side
        // margin: "0 auto",
      }}
    >
      <Slider
        {...settings}
        style={{
          position: "static",
          width: "580px", // Fixed width for the content area
          margin: "0 auto",
        }}
      >
        <div
          style={{
            width: "580px", // Fixed width for slides
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: "scale(0.967)", // 580/600 to scale down the wordcloud proportionally
          }}
        >
          {wordcloud1}
        </div>
        <div
          style={{
            width: "580px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: "scale(0.967)",
          }}
        >
          {wordcloud2}
        </div>
        <div
          style={{
            width: "580px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transform: "scale(0.967)",
          }}
        >
          {wordcloud3}
        </div>
      </Slider>
      <style>
        {`
          .slick-slide {
            width: 570px !important;
          }
          .slick-list {
            overflow: hidden !important;
          }
          .slick-track {
            display: flex;
            align-items: center;
          }
          .slick-prev, .slick-next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            width: 10px;
            height: 10px;
          }
          .slick-prev {
            left: 0;
          }
          .slick-next {
            right: 0;
          }
          .slick-prev:before, .slick-next:before {
            font-size: 15px; // Reduced size for smaller arrows
            opacity: 0.75;
          }
        `}
      </style>
    </div>
  );
};

export default Carousel;
